import React from "react";

const Title = ({ text }) => {
  return <h4 className="my-0 font-roboto-bold text-20 text-primary-text font-roboto-medium">{text}</h4>;
};

export default Title;
